// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_b1-0";
export var optionCard = "_b1-1";